import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatSortModule } from '@angular/material/sort';
import { MaterialModule } from '@sdbn/appclient';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { InputIntegerModule } from 'src/tmc-common/components/input-integer/input-integer.module';
import { StructureNodeSelectionModule } from 'src/tmc-yard/components/structure-node-selection/structure-node-selection.module';
import { ReportFilterDetailsDialogComponent } from './component/report-filter-details-dialog.component';
import { ReportFilterComponent } from './component/report-filter.component';

@NgModule({
  declarations: [
    ReportFilterComponent,
    ReportFilterDetailsDialogComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    CommonUIModule,
    MaterialModule,
    MatTableModule,
    MatSortModule,
    ReactiveFormsModule,
    FormsModule,
    StructureNodeSelectionModule,
    InputIntegerModule
  ],
  exports: [
    ReportFilterComponent,
  ]
})
export class ReportFilterModule { }
